import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="cctv--archive-time-line"
export default class extends Controller {

  connect() {
    this.flatpickr = flatpickr(this.element, {
      inline: true,
      enableTime: false,
      enableSeconds: false,
      dateFormat: "Y-m-d",
      maxDate: "today",
      time_24hr: false,
      altInput: false,
      onChange: this.onDateChange.bind(this)
    });

    this.fireDateChange(this.flatpickr.selectedDates[0])
  }


  onDateChange(selectedDates) {
    this.clear()
    let selectedDate = selectedDates[0]
    // Format the date as YYYY-MM-DD
    const year = selectedDate.getFullYear()
    const month = String(selectedDate.getMonth() + 1).padStart(2, "0") // month is 0-indexed
    const day = String(selectedDate.getDate()).padStart(2, "0")
    const dateParam = `${year}-${month}-${day}`

    let data = {}
    document.dispatchEvent(new CustomEvent("archive:play", {
      bubbles: true,
      detail: {callback: (state) => data = state}
    }));


    let camerasData = {}
    document.dispatchEvent(new CustomEvent("selectedCameras:camera", {
      bubbles: true,
      detail: {callback: (state) => camerasData = state}
    }));


    // Update the URL query parameter using Turbo
    const url = new URL(window.location)
    if (camerasData['cameraIds'].length > 0) {
      url.searchParams.set("cameraIds", camerasData['cameraIds']);
    }
    if (Object.keys(data).length > 0) {
      const minTime = data['min'].toTimeString().split(' ')[0];
      const maxTime = data['max'].toTimeString().split(' ')[0];
      url.searchParams.set("date", dateParam);
      url.searchParams.set("minDateTime", `${dateParam}T${minTime}`);
      url.searchParams.set("maxDateTime", `${dateParam}T${maxTime}`);
    } else {
      url.searchParams.set("date", dateParam);
    }

    Turbo.visit(url.toString())

    // if (selectedDates.length > 0) {
    //   this.fireDateChange(selectedDates[0])
    // }
  }

  fireDateChange(date) {
    const event = new CustomEvent("datePicker:changed", {
      detail: {date: date},
      bubbles: true
    })
    this.element.dispatchEvent(event)
  }

  clear() {
    if (this.flatpickr) {
      this.flatpickr.destroy();
      this.flatpickr = null;
    }
  }

  disconnect() {
    this.clear()
    super.disconnect();
  }


}
